import {Form, FormButton, FormField} from 'platform/components';
import {VStack} from 'platform/foundation';
import {z} from 'zod';

import {useGetOperationItemsQuery} from '@dms/api/finance';
import i18n from '@dms/i18n';

interface WorkItemGroupDialogProps {
  onClose: () => void;
  onSubmit: (workItemGroupId: string) => void;
}

const workItemGroupFormSchema = z.object({
  workItemGroupId: z.string().min(1),
});

type WorkItemGroupForm = z.infer<typeof workItemGroupFormSchema>;

export function WorkItemGroupDialog(props: WorkItemGroupDialogProps) {
  const {data: operationItems, isLoading} = useGetOperationItemsQuery({
    application: 'workshop',
    itemGroup: 'work',
  });

  const handleSubmit = async (values: WorkItemGroupForm) => {
    await props.onSubmit(values.workItemGroupId);
    props.onClose();
  };

  const options =
    operationItems?.map((item) => ({
      label: item.itemCodeName,
      value: item.operationId,
    })) ?? [];

  return (
    <Form onSubmit={handleSubmit} experimentalZodSchema={workItemGroupFormSchema}>
      {(control) => (
        <VStack spacing={4}>
          <FormField
            menuInPortal
            control={control}
            name="workItemGroupId"
            type="choice"
            label={i18n.t('entity.addWork.labels.workItemGroup')}
            isRequired
            isLoading={isLoading}
            options={options}
          />
          <FormButton control={control} type="submit" title={i18n.t('general.actions.confirm')} />
        </VStack>
      )}
    </Form>
  );
}
